import React from "react";
import { Gradient } from "./styles";
import { Params } from "./types";

const ImageGradientLeft = ({ color, children }: Params) => {
    return <Gradient color={color}>{children}</Gradient>;
};

export default ImageGradientLeft;
